import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';
import { environment } from '../../environments/environment';

export const subscriptionInterceptor: HttpInterceptorFn = (request, next) => {
  const router = inject(Router);

  if (!request.url.startsWith(environment.apiUrl)) {
    return next(request);
  }

  return next(request).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status === 402) {
        void router.navigate(['/account/subscription']);
      }

      return throwError(() => error);
    }),
  );
};
